import React from 'react';

export default function ButtonDetailsRequestsHotels(props) {
    const {
        button,
        className = ''
    } = props;

    return (
        <div className={"card border-none bg-white p-3 " + className}>
            {
                <div className={"d-flex align-items-center text-center m-auto font-weight-bold "+button.labelColor}>
                    {button.label}
                </div>
            }
        </div>
    );

}